// extracted by mini-css-extract-plugin
module.exports = {"container":"Stop_container__3DQw1","serie":"Stop_serie__1LEFT","box":"Stop_box__2XdPt","theme":"Stop_theme__3d6SK"};